import { Link } from "react-router-dom";
import styles from "./featured-tournaments.module.css"

const GamesCard = ({ tournament }) => {
    function pretty(str) {
        return str
            .split("_")
            .map(w => w.length > 2 ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w.toUpperCase())
            .join(" ");
    }
    function formatDate(dateStr) {
        const d = new Date(dateStr);
        return d.toLocaleDateString("en-IN", {
            day: "2-digit",
            month: "long",
            year: "numeric"
        });
    }

    return (
        <div className={styles.tournamentCard}>
            <div className={styles.cardImageContainer}>
                <img src={
                    tournament.bannerImage && tournament.bannerImage!=="undefined"
                    ? tournament.bannerImage
                    : "/placeholder.webp"
                } alt={tournament.title} className={styles.cardImage} />
                <div className={styles.cardOverlay} />
                <div className={styles.gameBadge}>{tournament.game}</div>
                <div className={styles.statusBadge}>{pretty(tournament.status)}</div>
            </div>

            <div className={styles.cardContent}>
                <h3 className={styles.cardTitle}>{tournament.name}</h3>

                <div className={styles.cardDetails}>
                    <div className={styles.detailRow}>
                        <span className={styles.detailLabel}>Registration Fee:</span>
                        <span className={styles.detailValue}>{tournament.registrationPrice === 0 ? "Free" : `₹${tournament.registrationPrice}`}</span>
                    </div>
                    <div className={styles.detailRow}>
                        <span className={styles.detailLabel}>Prize Pool:</span>
                        <span className={styles.detailValue}>{tournament.prizePool}</span>
                    </div>
                    <div className={styles.detailRow}>
                        <span className={styles.detailLabel}>Max Players:</span>
                        <span className={styles.detailValue}>{tournament.maxPlayers}</span>
                    </div>
                    <div className={styles.detailRow}>
                        <span className={styles.detailLabel}>Participants:</span>
                        <span className={styles.detailValue}>{tournament.currentRegistrations}</span>
                    </div>
                </div>

                <div className={styles.registrationInfo}>
                    <span className={styles.registrationLabel}>Registration Ends</span>
                    <span className={styles.registrationDate}>{formatDate(tournament.registrationDeadline)}</span>
                </div>

                <Link to={`/tournament/detail/${tournament._id}`}>
                    <button className={styles.registerBtn}>
                        Register Now
                        <span className={styles.btnIcon}>→</span>
                    </button>
                </Link>
            </div>
        </div>
    )
}

export default GamesCard